import { FieldValues, Path, useFormContext } from "react-hook-form";
import { Sidebar } from "primereact/sidebar";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DropdownFilterEvent } from "primereact/dropdown";

import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import { useFormDropdownHolidayTypeContext } from "./form-dropdown-holiday-type.context";

export interface FormDropdownHolidayTypeProps<T extends FieldValues> {
  name: Path<T>;
  allowCreate?: boolean;
}

export function FormDropdownHolidayType<T extends FieldValues>({
  name,
  allowCreate = false,
}: FormDropdownHolidayTypeProps<T>) {
  const hintText = allowCreate
    ? `Select from the created holidayType dropdown. Otherwise, hit ENTER to create a new holidayType. If the holidayType doesn't exist select N/A`
    : "";
  const { control } = useFormContext<T>();
  const {
    sidebar,
    newHolidayType,
    mappedHolidayType,
    isCreating,
    setSidebar,
    setFilter,
    setNewHolidayType,
    handleFilterInput,
    handleAdd,
  } = useFormDropdownHolidayTypeContext();
  
  return (
    <div className="holiday-type">
      {newHolidayType && (
        <Sidebar visible={sidebar} onHide={() => setSidebar(false)}>
          <h2>Create new holidayType</h2>
          <p>
            You are creating a new holidayType. Please, fill the fields to create a
            new holidayType and apply to current item creation.
          </p>
          <div className="flex flex-col gap-2 mt-4">
            <InputText
              placeholder="HolidayType Name"
              value={newHolidayType.name}
              onChange={(e: any) =>
                setNewHolidayType({ ...newHolidayType, name: e.target.value })
              }
            />
            <InputText
              placeholder="HolidayType Description"
              value={newHolidayType.description}
              onChange={(e: any) =>
                setNewHolidayType({ ...newHolidayType, description: e.target.value })
              }
            />

            <Button
              label="Create"
              onClick={handleAdd}
              className="block"
              disabled={isCreating}
            />
          </div>
        </Sidebar>
      )}
      <DropdownControl<T>
        control={control}
        name={name}
        label="HolidayType"
        options={ mappedHolidayType }
        containerClassName="mb-9"
        className="w-full md:w-3/4"
        placeholder="Enter your holidayType"
        hint={hintText}
        filter
        onFilter={(e: DropdownFilterEvent) => setFilter(e.filter)}
        onKeyDown={allowCreate ? handleFilterInput : () => {}}
      />
    </div>
  );
}

export default FormDropdownHolidayType;